const notificationTypes = {
  ERROR: 'error',
  SUCCESS: 'success',
};

export default notificationTypes;
